import { canonicalAccord } from './reviews.js';

// Recorded profiles spell some accords more than one way; each spelling maps to one key so a filter,
// a comparison row and a search all mean the same accord.
const ACCORD_ALIASES: Record<string, string> = {
  leathery: 'leather',
  woods: 'woody',
  wood: 'woody',
  musk: 'musky',
  marine: 'aquatic',
  'warm-spicy': 'warm spicy',
};

/** The comparison score at which an accord counts as noticeable, the level an accord filter asks for. */
export const NOTICEABLE_ACCORD = 3;
const MAX_ACCORD_FILTERS = 8;

/** One lower-case key per accord, with alternative spellings folded together. */
export function accordKey(name: string) {
  const key = name.trim().toLocaleLowerCase('en').replace(/\s+/g, ' ');
  return ACCORD_ALIASES[key] ?? key;
}

/** Every recorded spelling that belongs to a key, for matching stored profiles. */
export function accordSpellings(key: string) {
  return [key, ...Object.keys(ACCORD_ALIASES).filter((alias) => ACCORD_ALIASES[alias] === key)];
}

/** The display name for a key: the review vocabulary's spelling when it has one. */
export function accordLabel(key: string, fallback?: string) {
  return canonicalAccord(key) ?? fallback ?? key.replace(/(^|\s)\S/g, (letter) => letter.toUpperCase());
}

/** The accord filter from a query string: known-shaped keys only, de-duplicated and capped. */
export function parseAccordFilter(value: unknown) {
  if (typeof value !== 'string') return [];
  const keys = value.slice(0, 400).split(',').map(accordKey).filter((key) => /^[a-z][a-z -]{0,39}$/.test(key));
  return [...new Set(keys)].slice(0, MAX_ACCORD_FILTERS);
}
